<template>
  <div class="order-stack">
    <div class="header mr-1.5" ref="header">
      <el-popover ref="full-filters" placement="bottom" trigger="click">
        <ContainerFilter :filter="filter" @search="searchOrders" />
      </el-popover>
      <el-popover ref="settings" placement="right" width="320" trigger="click">
        <div class="el-cards">
          <el-card class="dense flat" shadow="never">
            <div slot="header" class="clearfix flex-space">
              <span>Settings</span>
              <a @click="moreSettings = !moreSettings">
                <i class="el-icon-arrow-up bold" v-if="moreSettings" />
                <i class="el-icon-arrow-down bold" v-else />
              </a>
            </div>
            <label>Operation Display</label>
            <el-radio-group
              v-model="opsDisplay"
              size="mini"
              @change="updateSettings({ orderStackOpsDisplay: opsDisplay })"
            >
              <el-radio label="default">Default</el-radio>
              <el-radio label="expand">Expand</el-radio>
              <el-radio label="collapse">Collapse</el-radio>
            </el-radio-group>
            <label>Check Markers</label>
            <el-button
              size="mini"
              class="micro"
              type="danger"
              plain
              @click.stop="resetCheckMarkers('o')"
              >Clear Order Markers</el-button
            >
            <el-button
              size="mini"
              class="micro"
              type="danger"
              plain
              @click.stop="resetCheckMarkers('r')"
              >Clear Route Markers</el-button
            >
            <slot v-if="moreSettings">
              <label> Sort Columns: drag&sort </label>
              <div class="sort-columns">
                <div class="box">
                  <div class="box-title flex-space">
                    <div>Drayage Orders</div>
                    <a @click="resetColumns(target)">reset</a>
                  </div>
                  <div class="box-content">
                    <draggable
                      v-model="columnOptions"
                      class="stripe"
                      draggable=".stripe-item"
                      ghost-class="ghost"
                      @change="moveColumn"
                    >
                      <div
                        v-for="column in columnOptions"
                        :key="column.name"
                        class="stripe-item"
                      >
                        <el-checkbox
                          v-if="!column.disabled"
                          v-model="column.visible"
                          :disabled="column.name == 'ID'"
                          @change="toggleColumn($event, column.name)"
                          >{{ column.name }}</el-checkbox
                        >
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </slot>
          </el-card>
        </div>
      </el-popover>
      <el-form size="mini" class="flex items-center gap-0.5">
        <el-popover
          v-if="isAdmin && !isEmptyData(selectors)"
          ref="shipments"
          placement="bottom"
          class="-mt-0.5"
          width="600"
          trigger="click"
        >
          <div class="flex flex-col gap-1">
            <div
              v-for="item in selectors"
              :key="item.id"
              class="tag flex items-center gap-1"
            >
              <a
                class="el-icon-remove red text-base mr-0.5"
                @click.stop="unselectItem(item)"
              />
              <b>{{ item.id }}</b>
              <div>{{ item.info }}</div>
            </div>
          </div>
          <fieldset class="form">
            <legend>Shipments</legend>
            <el-form label-position="top" size="mini">
              <el-form-item label="Track Shipment URL">
                <el-input
                  v-model="shipmentUrl"
                  size="mini"
                  style="width: 580px"
                >
                  <el-button slot="append" size="mini" type="success">
                    <e-copy :text="shipmentUrl" class="mt-1" />
                  </el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </fieldset>
          <el-button slot="reference" size="mini" type="primary" class="narrow">
            <i class="el-icon-share" /> Shipment URL
          </el-button>
        </el-popover>
        <popup
          v-if="editBatchable"
          componentPath="pages/containers/replica"
          width="99%"
          height="100%"
          :pivot-y="0"
          :click-to-close="false"
          :options="batchOrderOptions"
        >
          <el-button size="mini" class="narrow"> Batch Edit </el-button>
        </popup>
        <el-tooltip
          v-else
          placement="bottom"
          content="Only support the orders within the same type and hub; Query orders by using full filters"
          :open-delay="500"
        >
          <el-button size="mini" class="narrow">
            <i class="el-icon-warning red" /> Batch Edit
          </el-button>
        </el-tooltip>
        <el-button
          v-if="!isEmptyData(trashItems)"
          icon="el-icon-delete"
          size="mini"
          type="danger"
          class="narrow"
          @click="deleteOrders"
        >
          Batch Delete ({{ trashItems.length }})
        </el-button>
        <el-button
          v-popover:full-filters
          icon="el-icon-search"
          size="mini"
          trigger="click"
          class="narrow"
        >
          Full Filters
        </el-button>
        <el-input
          clearable
          placeholder="Quick Table Filter"
          v-model.lazy="keyword"
          size="mini"
          style="width: 200px"
        >
          <i slot="prefix" class="el-input__icon el-icon-s-grid" />
        </el-input>
        <el-button
          v-popover:settings
          icon="el-icon-setting"
          size="mini"
          class="narrow"
        >
          Settings
        </el-button>
        <el-button
          v-if="!isTrucker"
          size="mini"
          @click="exportCsv()"
          title="Max 5000 Records"
          class="narrow"
        >
          Export to CSV
        </el-button>
        <el-radio-group
          v-model="filter.type_eq"
          size="mini"
          :disabled="pagination.loading"
        >
          <el-radio-button label="">All</el-radio-button>
          <el-radio-button label="ImportContainer">
            <div class="flex items-center">
              <div>Import</div>
              <slot v-if="isAdmin && filter.type_eq == 'ImportContainer'">
                <el-divider direction="vertical" />
                <el-checkbox v-model="onlyIbi">Only IBI</el-checkbox>
              </slot>
            </div>
          </el-radio-button>
          <el-radio-button label="ExportContainer">
            <div class="flex items-center">
              <div>Export</div>
              <slot v-if="isAdmin && filter.type_eq == 'ExportContainer'">
                <el-divider direction="vertical" />
                <el-checkbox v-model="onlyObi">Only OBI</el-checkbox>
              </slot>
            </div>
          </el-radio-button>
          <el-radio-button label="XtownContainer">XTown</el-radio-button>
        </el-radio-group>
      </el-form>
    </div>
    <ContainerOrderStackTable
      ref="table"
      :items="filteredItems"
      :financials="financials"
      @initColumnOptions="initColumnOptions"
    />
    <center>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pagination.pageSize"
        :current-page="pagination.currentPage"
        :total="pagination.total"
        @current-change="pageChange($event)"
      />
    </center>
  </div>
</template>

<script>
import api from "@/default/utils/api";
import ContainerFilter from "@/default/pages/containers/filter.vue";
import ContainerOrderStackTable from "@/default/pages/containers/order_stack/table.vue";

export default {
  name: "ContainerOrderStack",
  mixins: [api],
  components: {
    ContainerFilter,
    ContainerOrderStackTable,
  },
  props: {
    hubId: {
      type: Number,
      required: true,
    },
    financials: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      moreSettings: true,
      opsDisplay: "default",
      filter: {
        hub_id_eq: this.hubId,
        type_eq: "",
        confirmed_eq: null,
        dispatched: null,
        locked_eq: null,
        page_size: 50,
      },
      onlyIbi: false,
      onlyObi: false,
      keyword: "",
      columnOptions: [],
      items: [],
      selectors: [],
      shipmentUrl: "",
      firstLoaded: false,
      pagination: {
        pageSize: 50,
        currentPage: 1,
        total: 0,
        loading: false,
      },
      fuseOptions: {
        shouldSort: true,
        threshold: 0.25,
        location: 0,
        distance: 50,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "id",
          "container_no",
          "chassis_no",
          "ssline_bl_no",
          "terminals.name",
          "ssline.name",
          "customer.name",
          "warehouses.name",
          "warehouses.city",
          "truckers.name",
        ],
      },
    };
  },
  async mounted() {
    this.moveHeader();
    window.addEventListener("ContainerSelector", this.loadSelectors);
    window.addEventListener("ReloadOrder", this.reloadOrder);
    await this.loadOrders();
  },
  beforeDestroy() {
    window.removeEventListener("ContainerSelector", this.loadSelectors);
  },
  watch: {
    firstLoaded(nv, ov) {
      if (nv != ov) {
        this.loadSelectors();
      }
    },
    "filter.type_eq"(nv, ov) {
      if (nv != ov) {
        this.searchOrders();
      }
    },
    onlyIbi(nv, ov) {
      if (nv != ov) {
        this.searchOrders();
      }
    },
    onlyObi(nv, ov) {
      if (nv != ov) {
        this.searchOrders();
      }
    },
    selectors(nv, ov) {
      if (JSON.stringify(nv) != JSON.stringify(ov)) {
        const ids = nv.map((o) => o.id);
        this.activeTab = "selected-orders";
        this.items.forEach((item) =>
          this.$set(item, "selected", ids.includes(item.id)),
        );
      }
    },
  },
  computed: {
    vetable() {
      return this.$refs.table.$refs.table;
    },
    filteredItems() {
      let items = this.items;
      const term = this.keyword.trim();
      if (term.length >= 3) {
        items = this.$search(term, items, this.fuseOptions).map((o) => o.item);
      }
      items.forEach((item) => {
        item.operated = item.transports.some(
          (o) => o.operations.filter((o) => o.operated_at).length > 0,
        );
      });
      return items;
    },
    trashItems() {
      return this.filteredItems.filter((o) => o.trash);
    },
    editBatchable() {
      return (
        this._.uniq(this.filteredItems.map((o) => [o.type, o.hub_id].join("-")))
          .length == 1
      );
    },
    batchOrderOptions() {
      const { type } = this.filteredItems[0];
      const ids = this.filteredItems.map((o) => o.id);
      return { mode: "edit", master: { type }, ids };
    },
  },
  methods: {
    moveHeader() {
      const btns = document.querySelector(".title-bar .buttons");
      if (btns) btns.appendChild(this.$refs.header);
    },
    initColumnOptions() {
      return (this.columnOptions = this.getTableColumns("order-stack"));
    },
    resetColumns() {
      this.$actions.updateTableColumns({ ["order-stack"]: [] });
      this.$refs.table.initCachedColumns();
    },
    toggleColumn(checked, name) {
      this.updateTableColumn("order-stack", name, { visible: checked });
    },
    moveColumn() {
      this.columnOptions.forEach((column, index) => {
        column.order = index + 1;
      });
      this.$actions.updateTableColumns({ ["order-stack"]: this.columnOptions });
    },
    reloadOrder(event) {
      const id = parseInt(event.detail);
      let index = this.items.findIndex((o) => o.id == id);
      if (index >= 0) {
        this.$http
          .get(`/api/v1/containers/${id}`, { params: { mode: "order-stack" } })
          .then((response) => {
            const item = this.processItems([response.data])[0];
            this.items.splice(index, 1, item);
          })
          .catch((err) => {});
      }
    },
    async loadOrders() {
      try {
        this.vetable.loading();
        this.pagination.loading = true;
        const q = { ...this.filter };
        delete q.page_size;
        if (this.filter.type_eq == "ImportContainer" && this.onlyIbi)
          q["ibi_true"] = true;

        if (this.filter.type_eq == "ExportContainer" && this.onlyObi)
          q["obi_true"] = true;
        const response = await this.$http.get("/api/v1/containers", {
          params: {
            q,
            page: this.pagination.currentPage,
            page_size: this.filter.page_size,
          },
        });
        this.firstLoaded = true;
        this.pagination.currentPage = parseInt(response.data.current_page);
        this.pagination.pageSize = parseInt(response.data.page_size);
        this.pagination.total = parseInt(response.data.total);

        const containers = response.data.containers;
        if (containers.length > 0) {
          this.items = this.processItems(containers);
        }
      } catch (ex) {
        this.$message({ message: ex.response.data.errors, type: "error" });
      } finally {
        this.vetable.loaded();
        this.pagination.loading = false;
      }
    },
    async searchOrders() {
      this.pagination.currentPage = 1;
      this.items = [];
      await this.loadOrders();
    },
    async pageChange(val) {
      this.pagination.currentPage = val;
      await this.loadOrders();
    },
    async deleteOrders() {
      let ids = [];
      let errors = {};
      try {
        const result = await this.$confirm(
          `Are you sure to batch delete orders?`,
        );
        if (result == "confirm") {
          ids = this.trashItems.map((o) => o.id);
          await this.$http.patch("/api/v1/containers/delete", { ids });
        }
      } catch (ex) {
        errors = ex.response.data.errors;
      } finally {
        let list = "";
        for (const id in errors) {
          list += `<li>${id}: ${errors[id]}</li>`;
          ids.splice(ids.indexOf(parseInt(id)), 1);
        }
        let div = `
          <div>
            <div class="bold green my-1">Deleted Orders: ${ids.join(", ")}</div>
            <div class="bold red">Undeletable Orders:</div>
            <ul class="circle red">${list}</ul>
          </div>
        `;
        this.$alert(div, "Batch Delete Result", {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
        });
        ids.forEach((id) => {
          let index = this.items.findIndex((o) => o.id == id);
          if (index >= 0) this.items.splice(index, 1);
        });
      }
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      const cs = this._.uniqBy(
        this._.flatten(
          item.transports.map((o) => o.operations.map((o) => o.company)),
        ),
        "id",
      );

      item.terminals = cs.filter((o) => ["Terminal"].includes(o.type));
      item.warehouses = cs.filter((o) => ["Warehouse"].includes(o.type));
      item.truckers = item.transports.map((o) => [o.trucker, o.carrier]);
      item.truckers = item.truckers.flat().filter((o) => o.id);

      if (this.isAdmin || this.isCustomer) {
        item.receivable_invoice_numbers = item.receivable.invoices
          .map((o) => o.number)
          .join(";");
        item.receivable_payment_numbers = item.receivable.payments
          .map((o) => o.number)
          .join(";");
        item.receivable_amount = parseFloat(item.receivable.charges.amount);
      }
      if (this.isAdmin || this.isTrucker) {
        item.payable_invoice_numbers = item.payable.invoices
          .map((o) => o.number)
          .join(";");
        item.payable_payment_numbers = item.payable.payments
          .map((o) => o.number)
          .join(";");
        item.payable_amount = parseFloat(item.payable.charges.amount);
      }

      return item;
    },
    exportCsv() {
      const q = { ...this.filter };
      delete q.page_size;
      this.getDownload("/api/v1/containers.csv", { q });
    },
    loadSelectors() {
      if (this.isAdmin) {
        this.$http
          .get("/api/v1/container_selectors")
          .then((response) => {
            const data = response.data;
            this.selectors = data.selectors;
            this.shipmentUrl = data.shipment_url;
          })
          .catch((err) => {});
      }
    },
    unselectItem(item) {
      this.$http
        .delete(`/api/v1/container_selectors/${item.id}`)
        .then((response) => {
          this.loadSelectors();
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.header::v-deep {
  .el-radio-button__inner {
    .el-checkbox {
      @apply m-0 h-3 flex items-center #{!important};
      .el-checkbox__input {
        @apply top-0.5;
        &.is-checked .el-checkbox__inner {
          @apply bg-green-400;
        }
      }
      .el-checkbox__label {
        @apply text-white text-2xs font-bold #{!important};
      }
    }
  }
}
.sort-columns {
  .box-content {
    @apply h-96 px-1 py-0.5 overflow-auto #{!important};
  }
}
</style>
